import { render } from "./FrancaisGenreGroupingSelect.vue?vue&type=template&id=05d9ec62"
import script from "./FrancaisGenreGroupingSelect.vue?vue&type=script&lang=js"
export * from "./FrancaisGenreGroupingSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__